import { createMarketplaceEventFactory } from '../index';
export const getMarketplaceAdminInteractionEvent = createMarketplaceEventFactory('Marketplace Admin', 'Interaction');